import { useState } from "react";
import "./SecuritySettings.css";

import {
  MdLock,
  MdEmail,
  MdPhone,
  MdDevices,
  MdHistory,
  MdLogout,
  MdSave,
} from "react-icons/md";

function SecuritySettings() {
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [emailData, setEmailData] = useState({
    currentEmail: "business@example.com",
    newEmail: "",
  });

  const [phoneData, setPhoneData] = useState({
    currentPhone: "+91 9876543210",
    newPhone: "",
  });

  const activeDevices = [
    {
      id: 1,
      device: "Chrome • Windows 11",
      location: "Bangalore, India",
      current: true,
    },
    {
      id: 2,
      device: "Chrome • Android",
      location: "Bangalore, India",
      current: false,
    },
  ];

  const loginHistory = [
    {
      id: 1,
      date: "Today • 09:45 AM",
      device: "Chrome • Windows",
    },
    {
      id: 2,
      date: "Yesterday • 08:15 PM",
      device: "Android",
    },
    {
      id: 3,
      date: "15 Jul 2026 • 07:10 PM",
      device: "Chrome • Windows",
    },
  ];

  const handlePasswordChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEmailChange = (e) => {
    setEmailData({
      ...emailData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePhoneChange = (e) => {
    setPhoneData({
      ...phoneData,
      [e.target.name]: e.target.value,
    });
  };

  const updatePassword = () => {
    alert("Password update API will be connected.");
  };

  const updateEmail = () => {
    alert("Email update API will be connected.");
  };

  const updatePhone = () => {
    alert("Phone update API will be connected.");
  };

  const logoutAllDevices = () => {
    if (window.confirm("Logout from all devices?")) {
      alert("Logout API will be connected.");
    }
  };

  return (
    <div className="security-page">

      <div className="security-header">
        <h1>Security</h1>
        <p>
          Manage your account security and login settings.
        </p>
      </div>

      {/* Change Password */}

      <div className="security-card">

        <h2>
          <MdLock />
          Change Password
        </h2>

        <input
          type="password"
          name="currentPassword"
          placeholder="Current Password"
          value={passwordData.currentPassword}
          onChange={handlePasswordChange}
        />

        <input
          type="password"
          name="newPassword"
          placeholder="New Password"
          value={passwordData.newPassword}
          onChange={handlePasswordChange}
        />

        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm Password"
          value={passwordData.confirmPassword}
          onChange={handlePasswordChange}
        />

        <button onClick={updatePassword}>
          <MdSave />
          Update Password
        </button>

      </div>

      {/* Email */}

      <div className="security-card">

        <h2>
          <MdEmail />
          Change Email
        </h2>

        <input
          type="text"
          value={emailData.currentEmail}
          disabled
        />

        <input
          type="email"
          name="newEmail"
          placeholder="New Email"
          value={emailData.newEmail}
          onChange={handleEmailChange}
        />

        <button onClick={updateEmail}>
          <MdSave />
          Update Email
        </button>

      </div>

      {/* Phone */}

      <div className="security-card">

        <h2>
          <MdPhone />
          Change Phone Number
        </h2>

        <input
          type="text"
          value={phoneData.currentPhone}
          disabled
        />

        <input
          type="text"
          name="newPhone"
          placeholder="New Phone Number"
          value={phoneData.newPhone}
          onChange={handlePhoneChange}
        />

        <button onClick={updatePhone}>
          <MdSave />
          Update Phone
        </button>

      </div>

      {/* Active Devices */}

      <div className="security-card">

        <h2>
          <MdDevices />
          Active Devices
        </h2>

        {activeDevices.map((device) => (
          <div className="device-card" key={device.id}>

            <div>

              <h4>{device.device}</h4>

              <p>{device.location}</p>

            </div>

            {device.current ? (
              <span className="current-device">
                Current Device
              </span>
            ) : (
              <button className="logout-device">
                Logout
              </button>
            )}

          </div>
        ))}

      </div>

      {/* Login History */}

      <div className="security-card">

        <h2>
          <MdHistory />
          Login History
        </h2>

        {loginHistory.map((item) => (
          <div className="history-row" key={item.id}>

            <div>

              <h4>{item.date}</h4>

              <p>{item.device}</p>

            </div>

          </div>
        ))}

      </div>

      {/* Logout All */}

      <div className="danger-card">

        <h2>
          <MdLogout />
          Logout From All Devices
        </h2>

        <p>
          This will sign you out from every logged-in device.
        </p>

        <button
          className="danger-button"
          onClick={logoutAllDevices}
        >
          Logout All Devices
        </button>

      </div>

    </div>
  );
}

export default SecuritySettings;